import React from 'react';

/**
 * HOC similar to redux that separates data loading out of components
 * Returns function that wraps a component, passing in data when it has loaded
 * Useful for multiple components that share the same data
 * Waits until after subscribe() has resolved to call initialLoad to avoid missing changes
 *
 * @param {function} initialLoad - initialLoad(props)
 * @param {function|void} subscribe - subscribe(props) => Promise optional
 * @param {function|void} unsubscribe - unsubscribe(subscription) optional
 */
// TODO allow sharing of same Loader instance for efficiency
export const createLoader = (initialLoad, subscribe, unsubscribe) => (Component) => {
  class Loader extends React.Component {
    async componentDidMount() {
      if (subscribe) {
        this.gqlSubscriptions = await subscribe(this.props);
      }
      await initialLoad(this.props);
    }

    componentWillUnmount() {
      unsubscribe(this.gqlSubscriptions);
    }

    render() {
      return <Component {...this.props} />;
    }
  }
  Loader.displayName = `Loader`;

  return Loader;
};
export default createLoader;
